import CrossStorageService from "./crossStorageService.js";

export default CrossStorageService;
